import { render, staticRenderFns } from "./kakaoReturn.vue?vue&type=template&id=661a502a&scoped=true"
import script from "./kakaoReturn.vue?vue&type=script&lang=js"
export * from "./kakaoReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a502a",
  null
  
)

export default component.exports